<template>
  <ContentFrame
    :themeColor="computedTopicColor"
    :title="computedTitle"
  >
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('ksv.t1.title')"
      :textArray="[$t('ksv.t1.p0'), $t('ksv.t1.p1'), $t('ksv.t1.p2'), $t('ksv.t1.p3'), $t('ksv.t1.p4')]"
      :downloadText="$t('ksv.t1.download')"
      downloadFileName="KlinikSchulVerein.pdf"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('ksv.t2.title')"
      :textArray="[$t('ksv.t2.p0')]"
    >
      <ul slot="content">
        <li>{{ $t('ksv.t2.li0') }}</li>
        <li>{{ $t('ksv.t2.li1') }}</li>
        <li>{{ $t('ksv.t2.li2') }}</li>
        <li>{{ $t('ksv.t2.li3') }}</li>
        <li>{{ $t('ksv.t2.li4') }}</li>
        <li>{{ $t('ksv.t2.li5') }}</li>
        <li>{{ $t('ksv.t2.li6') }}</li>
        <li>{{ $t('ksv.t2.li7') }}</li>
      </ul>
    </ContentTile>
    <ContentImageTile
      imageSource="/img/grafiken/mithilfe-1.jpg"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('ksv.t3.title')"
      :textArray="[$t('ksv.t3.p0'), $t('ksv.t3.p1')]"
      :downloadText="$t('ksv.t3.download')"
      downloadFileName="KlinikSchulVerein_Beitrittserklaerung.pdf"
    >
      <v-card slot="content">
        <v-card-text>
          <p class="text-subtitle-1">
            {{ $t('ksv.t3.bankheading') }}
          </p>
          KlinikSchulVerein Ulm e.V.
          <br>IBAN: DE07 6305 0000 0002 1803 06
          <br>BIC: SOLADES1ULM
        </v-card-text>
      </v-card>
    </ContentTile>
  </ContentFrame>
</template>

<script>
import ContentFrame from '@/views/components/ContentFrame.vue'
import ContentTile from '@/views/components/ContentTile.vue'
import ContentImageTile from '@/views/components/ContentImageTile.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'KlinikSchulVerein',
  components: {
    ContentTile,
    ContentFrame,
    ContentImageTile
  },
  computed: {
    ...mapGetters([
      'menuData'
    ]),
    computedTopicColor () {
      return this.menuData.klinikschulverein.color
    },
    computedTitle () {
      return this.menuData.klinikschulverein.title
    }
  }
}
</script>
